import React from 'react';
import { Table } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import {
  IMassUploadItem,
  IMassUploadItemError,
  MassUploadItemStatus
} from '@epi-models/pages/MassUploadDetails';
import { OverflowTooltip } from '@epi-components/OverflowTooltip/OverflowTooltip';

import {
  TableContainer,
  StyledTable,
  TableHeaderCell,
  StyledRow,
  TableCell,
  StatusIndicator,
  ErrorContainer
} from '../MassUploadDetails.styles';
import { snakeCase } from 'lodash';

interface IProps {
  items: IMassUploadItem[];
}

export const MassUploadDetailsItemsTable = ({ items }: IProps) => {
  const { t } = useTranslation();

  return (
    <TableContainer>
      <StyledTable id="mass-upload-details-table">
        <Table.Head>
          <Table.Row>
            <TableHeaderCell width="20%">
              {t('containers.mass_upload.details.table.employee')}
            </TableHeaderCell>
            <TableHeaderCell width="25%">
              {t('containers.mass_upload.details.table.email')}
            </TableHeaderCell>
            <TableHeaderCell width="20%">
              {t('containers.mass_upload.details.table.status')}
            </TableHeaderCell>
            <TableHeaderCell>
              {t('containers.mass_upload.details.table.error_description')}
            </TableHeaderCell>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {items.map(item => {
            const hasErrors =
              item.status === MassUploadItemStatus.ClosedWithFailures;
            return (
              <StyledRow key={item.rowNumber} isError={hasErrors}>
                <TableCell width="20%">
                  <OverflowTooltip
                    arrow
                    placement="top"
                    title={`${item.firstName} ${item.lastName}`}
                  >
                    <span>{`${item.firstName} ${item.lastName}`}</span>
                  </OverflowTooltip>
                </TableCell>
                <TableCell width="25%">
                  <OverflowTooltip
                    arrow
                    placement="top"
                    title={item.emailAddress}
                  >
                    <span>{item.emailAddress}</span>
                  </OverflowTooltip>
                </TableCell>
                <TableCell width="20%">
                  <StatusIndicator isError={hasErrors}>
                    {t(
                      `containers.mass_upload.item_status.${snakeCase(
                        item.status
                      )}`
                    )}
                  </StatusIndicator>
                </TableCell>
                <TableCell>
                  {hasErrors ? (
                    <ErrorContainer>
                      <ul>
                        {item.errors.map((err: IMassUploadItemError) => {
                          const errorMessage = t(
                            `containers.mass_upload.validation_errors.${snakeCase(
                              err.fieldId
                            )}.${err.errorCode}`
                          );
                          return (
                            <li
                              key={`${item.rowNumber}-${err.fieldId}-${err.errorCode}`}
                            >
                              <OverflowTooltip
                                arrow
                                placement="top"
                                title={errorMessage}
                              >
                                <span>{errorMessage}</span>
                              </OverflowTooltip>
                            </li>
                          );
                        })}
                      </ul>
                    </ErrorContainer>
                  ) : (
                    '-'
                  )}
                </TableCell>
              </StyledRow>
            );
          })}
        </Table.Body>
      </StyledTable>
    </TableContainer>
  );
};
